import { gql } from '@apollo/client';

export const GET_USE_CASES = gql`
  query ($v1: UseCaseFiltersType, $v2: [String!]) {
    useCase {
      fetch(filters: $v1, sort: $v2) {
        name
        id
        createdAt
        updatedAt
        updatedBy {
          id
          username
        }
        libraryData
      }
    }
  }
`;

export const GET_USE_CASES_BY_ID = gql`
  query ($v1: UseCaseFiltersType) {
    useCase {
      get(filters: $v1) {
        id
        name
        description
        diagram {
          id
        }
        aiEnablers {
          id
        }
        subprocesses {
          id
        }
        generalData
        workPlanData
        libraryData
        formData
        organizationId
        aiValues
        hubble
        benefits
        nexus
        benefitsValues
      }
    }
  }
`;

export const GET_AI_SOLUTIONS = gql`
  query ($v1: AiSolutionFiltersType) {
    aiSolution {
      get(filters: $v1) {
        name
        description
        valueDriversScores
        func {
          id
        }
      }
    }
  }
`;

export const GET_CATEGORY_QUESTIONS = gql`
  query ($v1: CategoryQuestionFiltersType, $v2: [String!]) {
    categoryQuestion {
      fetch(filters: $v1, sort: $v2) {
        id
        createdAt
        updatedAt
        name
        __typename
      }
    }
    __typename
  }
`;

export const GET_QUESTION_BY_CATEGORY_ID = gql`
  query ($filters: QuestionFiltersType, $sort: [String!]) {
    question {
      fetch(filters: $filters, sort: $sort) {
        id
        createdAt
        updatedAt
        text
        answers
        questionType
        categoryId
      }
    }
  }
`;

export const GET_QUESTION_LIST = gql`
  query ($v1: QuestionFiltersType, $v2: [String!]) {
    question {
      fetch(filters: $v1, sort: $v2) {
        id
        createdAt
        updatedAt
        text
        answers
      }
    }
  }
`;

export const GET_CATEGORY_QUESTION_LINK = gql`
  query {
    categoryQuestion {
      fetch {
        id
        name
      }
    }
    question {
      fetch {
        id
        text
        categoryId
      }
    }
  }
`;

export const GET_ENTERPRISE_CONTEXT_FILTERS = gql`
  query ($v1: EnterpriseContextFiltersType, $v2: [String!]) {
    enterpriseContext {
      fetch(filters: $v1, sort: $v2) {
        id
        createdAt
        updatedAt
        enterpriseContext
      }
    }
  }
`;

export const SAVE_DATA_SOURCE = gql`
  mutation ($v1: UseCaseInputType!) {
    useCase {
      put(input: $v1) {
        id
      }
    }
  }
`;
